<main class="scan-cover" [class.photo-cover]="activePage() === 0">
  @switch (activePage()) {
    @case (0) {
      <section class="cover-page opening-page" data-test="cover-opening">
        <img
          class="opening-photo"
          src="assets/images/melkvermogen-cover.jpeg"
          alt=""
          draggable="false"
        />
        <div class="opening-copy">
          <h1>{{ 'dairyYieldScan.cover.openingTitle' | translate }}</h1>
          <p>{{ 'dairyYieldScan.cover.openingIntroduction' | translate }}</p>
        </div>
        <img
          class="agrifirm-logo"
          src="assets/images/agrifirm-logo-white.png"
          [alt]="'dairyYieldScan.cover.agrifirmLogoAlt' | translate"
          draggable="false"
        />
      </section>
    }
    @case (1) {
      <section class="cover-page formula-page" data-test="cover-formula">
        <p class="code-logo"><span>Code</span><strong>Melk</strong><span>Vermogen</span></p>
        <div class="formula-content">
          <img
            class="formula-image"
            src="assets/images/melkvermogen-formula.png"
            [alt]="'dairyYieldScan.cover.formulaImageAlt' | translate"
            draggable="false"
          />
          <p class="formula-explanation">
            <strong>{{ 'dairyYieldScan.cover.formulaExplanation' | translate }}</strong
            ><span>{{ 'dairyYieldScan.cover.formulaSituation' | translate }}</span>
          </p>
        </div>
      </section>
    }
    @case (2) {
      <section class="cover-page research-page" data-test="cover-research">
        <p class="code-logo"><span>Code</span><strong>Melk</strong><span>Vermogen</span></p>
        <div class="research-content">
          <section class="research-evidence" aria-labelledby="research-title">
            <h1 id="research-title">{{ 'dairyYieldScan.cover.researchTitle' | translate }}</h1>
            <div class="research-comparison">
              <article class="research-factor ration-factor">
                <img
                  src="assets/images/research-ration.jpeg"
                  [alt]="'dairyYieldScan.cover.rationPhotoAlt' | translate"
                  draggable="false"
                />
                <p><strong>45%</strong>{{ 'dairyYieldScan.cover.ration' | translate }}</p>
              </article>
              <article class="research-factor management-factor">
                <img
                  src="assets/images/research-management.jpeg"
                  [alt]="'dairyYieldScan.cover.managementPhotoAlt' | translate"
                  draggable="false"
                />
                <p>
                  <strong>55%</strong>{{ 'dairyYieldScan.cover.housingAndManagement' | translate }}
                </p>
              </article>
            </div>
            <p class="research-caption">{{ 'dairyYieldScan.cover.researchCaption' | translate }}</p>
            <small class="research-attribution">
              {{ 'dairyYieldScan.cover.researchAttribution' | translate }}
            </small>
          </section>
          <div class="research-action">
            <p class="research-conclusion">
              {{ 'dairyYieldScan.cover.researchConclusion' | translate }}
            </p>
            <p class="research-prompt">{{ 'dairyYieldScan.cover.researchPrompt' | translate }}</p>
            <button
              mat-flat-button
              color="primary"
              type="button"
              data-test="start-scan"
              (click)="startScan.emit()"
            >
              {{ 'dairyYieldScan.cover.action' | translate }}
              <mat-icon>arrow_forward</mat-icon>
            </button>
          </div>
        </div>
        <small class="research-source">{{
          'dairyYieldScan.cover.researchSource' | translate
        }}</small>
      </section>
    }
  }

  <nav
    class="cover-navigation"
    [attr.aria-label]="'dairyYieldScan.cover.navigationLabel' | translate"
  >
    @if (activePage() > 0) {
      <button
        mat-icon-button
        type="button"
        class="previous-page"
        data-test="previous-cover-page"
        [attr.aria-label]="'dairyYieldScan.cover.previous' | translate"
        (click)="previousPage()"
      >
        <mat-icon>arrow_back</mat-icon>
      </button>
    }
    <div class="page-indicators" aria-hidden="true">
      @for (page of [0, 1, 2]; track page) {
        <span [class.active]="activePage() === page"></span>
      }
    </div>
    @if (activePage() < 2) {
      <button
        mat-icon-button
        type="button"
        class="next-page"
        data-test="next-cover-page"
        [attr.aria-label]="'dairyYieldScan.cover.next' | translate"
        (click)="nextPage()"
      >
        <mat-icon>arrow_forward</mat-icon>
      </button>
    }
  </nav>
</main>
